<div *ngIf="mustBePresented()">
  <div>
    <p class="label">Would you like to start a Active test monitor?</p>
  </div>
  <div>
    <div class="app-list-item" *ngFor="let option of radioOptions">
      <div
        class="app-list-item__wrapper"
        [ngClass]="{ 'selected-item': option.selected }"
        (click)="_onClick(option)"
      >
        <i
          class="material-icons"
          [ngClass]="{ 'selected-item': option.selected }"
          >check</i
        >
        <div class="app-list-item__content">
          <div class="label">
            {{ translateLabel(option.label) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
